export const BadgeDisplay = ({ badges, BADGE_DEFINITIONS }) => {
  return (
    <div className="bg-gradient-to-br from-purple-900 to-indigo-900 border-4 border-purple-500 p-5 sm:p-6">
      <h3 className="text-xl font-black text-purple-400 uppercase mb-4">
        ALL BADGES ({badges.length}/{Object.keys(BADGE_DEFINITIONS).length})
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {Object.entries(BADGE_DEFINITIONS).map(([badgeId, badge]) => {
          const isUnlocked = badges.includes(badgeId);
          return (
            <div
              key={badgeId}
              className={`p-4 border-3 transition-all ${isUnlocked
                ? `${badge.bgColor} ${badge.borderColor}`
                : 'bg-gray-900 border-gray-700 opacity-50'
                }`}
            >
              <div className="flex items-start gap-3">
                <span className={`text-3xl ${isUnlocked ? '' : 'grayscale opacity-50'}`}>
                  {badge.icon}
                </span>
                <div className="flex-1">
                  <h4 className={`font-black text-sm uppercase mb-1 ${isUnlocked ? badge.color : 'text-gray-600'}`}>
                    {badge.name}
                  </h4>
                  <p className={`text-xs font-bold ${isUnlocked ? 'text-white' : 'text-gray-600'}`}>
                    {badge.description}
                  </p>
                </div>
                {isUnlocked && (
                  <span className="text-lime-400 font-black text-xl">✓</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
